// extracted by mini-css-extract-plugin
export default {"wrapper":"youtube__wrapper__A5RxE","prompt":"youtube__prompt__qKMmg","cta":"youtube__cta__qttoK","responsiveResize":"youtube__responsiveResize__e1ryh"};